import { Alert, Card, Typography } from 'antd';
import { useSearchParams } from 'react-router-dom-v5-compat';
import { useStoreActions, useStoreState } from '../store';
import { useEffect } from 'react';

const { Text } = Typography;

const UPS_AUTH_CODE_QUERY_PARAM = 'code';

const UpsVerifyPage = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get(UPS_AUTH_CODE_QUERY_PARAM);

  const registerUpsAuthCode = useStoreActions((actions) => actions.carrier.registerUpsAuthCode);
  const isUpsVerifyAuthCodeLoading = useStoreState((state) => state.carrier.registerUpsAuthCodeLoading);
  const upsVerifyAuthCodeError = useStoreState((state) => state.carrier.registerUpsAuthCodeError);

  useEffect(() => {
    if (code) {
      registerUpsAuthCode(code);
    }
  }, [code, registerUpsAuthCode]);

  let status = <></>;
  if (code && !upsVerifyAuthCodeError) {
    status = (
      <Alert
        message="Registration Verified"
        description={
          <>
            <Text>Your UPS account has been verfified you can close this browser tab.</Text>
          </>
        }
        type="success"
        showIcon
      />
    );
  } else {
    status = (
      <Alert
        message="Registration Incomplete"
        description={
          <>
            <Text>There was an issue verifying your UPS account. Please try again.</Text>
          </>
        }
        type="warning"
        showIcon
      />
    );
  }

  return (
    <>
      <Card title="UPS Verify" loading={isUpsVerifyAuthCodeLoading}>
        {status}
      </Card>
    </>
  );
};
export default UpsVerifyPage;
